const TitleText = (newTitle) => {
  return (document.title=newTitle)
}

export default TitleText